import React, { useEffect, useState } from 'react';
import { AiOutlineEdit, AiOutlineSave } from 'react-icons/ai';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import FormLangBar from '../../FormLangBar';
import { MwButton, MwInputText } from '../../ui';
import { langObjType } from '../../../utils/global';

const ResponsiblesForm = ({
    currentLangList,
    currentLangId,
    errors,
    responsibles,
    setResponsibles,
}) => {
    const [t] = useTranslation('global');
    const [formLang, setFormLang] = useState(currentLangId);
    const [responsible, setResponsible] = useState({
        name: langObjType(),
        mobileNo: '',
        email: '',
    });
    const [responsibleEditable, setResponsibleEditable] = useState({
        name: langObjType(),
        mobileNo: '',
        email: '',
    });
    const [editableMode, setEditableMode] = useState({ state: false, index: 0 });

    const AddToList = () => {
        if (!responsible.name?.[currentLangId]) return;

        setResponsibles([...responsibles, responsible]);
        setResponsible({
            name: langObjType(),
            mobileNo: '',
            email: '',
        });
    };

    const editItem = (index, item) => {
        setEditableMode({ state: true, index });
        setResponsibleEditable(item);
    };

    const updateItem = (index) => {
        responsibles[index] = responsibleEditable;
        setResponsibles([...responsibles]);
        setEditableMode({ state: false, index });
    };

    const deleteItem = (index) => {
        const filter = responsibles.filter((el, i) => i !== index);
        setResponsibles(filter);
    };

    const responsiblesList = responsibles?.map((item, index) => (
        <tr key={index} className='border-b border-slate-100 text-sm text-slate-600 last:border-b-0'>
            <td className='px-3 py-3 text-center font-medium text-slate-500'>{index + 1}</td>
            <td className='px-3 py-3'>
                {editableMode.state && editableMode.index === index ? (
                    <MwInputText
                        classNameInput='text-start'
                        value={responsibleEditable.name?.[currentLangId] || ''}
                        onChange={(e) =>
                            setResponsibleEditable({
                                ...responsibleEditable,
                                name: {
                                    ...responsibleEditable.name,
                                    [currentLangId]: e.target.value,
                                },
                            })
                        }
                    />
                ) : (
                    item.name?.[currentLangId] || t('vendors.noData')
                )}
            </td>
            <td className='px-3 py-3 text-center'>
                {editableMode.state && editableMode.index === index ? (
                    <MwInputText
                        value={responsibleEditable.mobileNo}
                        onChange={(e) =>
                            setResponsibleEditable({
                                ...responsibleEditable,
                                mobileNo: e.target.value,
                            })
                        }
                    />
                ) : (
                    item.mobileNo || t('vendors.noData')
                )}
            </td>
            <td className='px-3 py-3'>
                {editableMode.state && editableMode.index === index ? (
                    <MwInputText
                        classNameInput='text-start'
                        value={responsibleEditable.email}
                        onChange={(e) =>
                            setResponsibleEditable({
                                ...responsibleEditable,
                                email: e.target.value,
                            })
                        }
                    />
                ) : (
                    item.email || t('vendors.noData')
                )}
            </td>
            <td className='px-3 py-3'>
                <div className='flex justify-center gap-2 cursor-default'>
                    {editableMode.state && editableMode.index === index ? (
                        <MwButton actionType='button' type='secondary' size='sm' onClick={() => updateItem(index)}>
                            <AiOutlineSave size={18} />
                        </MwButton>
                    ) : (
                        <MwButton actionType='button' type='secondary' size='sm' onClick={() => editItem(index, item)}>
                            <AiOutlineEdit size={18} />
                        </MwButton>
                    )}
                    <MwButton actionType='button' type='secondary' size='sm' onClick={() => deleteItem(index)}>
                        <RiDeleteBin5Line size={18} />
                    </MwButton>
                </div>
            </td>
        </tr>
    ));

    useEffect(() => {
        console.log('Responsibles changed');
        console.log(responsible);
    }, [responsible]);

    return (
        <>
            <div>
                <div className='py-2'>
                    <FormLangBar
                        currentLangList={currentLangList}
                        formLang={formLang}
                        setFormLang={setFormLang}
                    />
                    {currentLangList.map((lang) => (
                        <div key={lang.langCode}>
                            <div className={`${formLang === lang?.langCode ? 'block' : 'hidden'}`}>
                                <MwInputText
                                    label={`${t('vendors.responsibleName')} (${lang?.langName})`}
                                    id={`nameResponsible${lang?.langCode}`}
                                    value={responsible.name?.[lang?.langCode]}
                                    invalid={!!errors[`nameResponsible.${lang?.langCode}`]}
                                    invalidMsg={errors[`nameResponsible.${lang?.langCode}`]}
                                    onChange={(e) => {
                                        setResponsible({
                                            ...responsible,
                                            name: {
                                                ...responsible.name,
                                                [lang?.langCode]: e.target.value,
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <div className='py-2'>
                    <MwInputText
                        label={t('vendors.responsibleMobile')}
                        id='mobileNo'
                        inputType='number'
                        value={responsible.mobileNo}
                        invalid={!!errors.mobileNo}
                        invalidMsg={errors.mobileNo}
                        onChange={(e) => {
                            setResponsible({ ...responsible, mobileNo: e.target.value });
                        }}
                    />
                </div>

                <div className='py-2'>
                    <MwInputText
                        label={t('vendors.responsibleEmail')}
                        id='emailresponse'
                        inputType='email'
                        value={responsible.email}
                        onChange={(e) => {
                            setResponsible({ ...responsible, email: e.target.value });
                        }}
                    />
                </div>

                <div className='mt-2'>
                    <MwButton onClick={AddToList} actionType='button' type='saveBtn' size='sm'>
                        {t('vendors.saveResponsible')}
                    </MwButton>
                </div>

                {responsibles.length > 0 && (
                    <div className='mt-5'>
                        <div className='mb-3 text-sm font-semibold text-slate-700'>
                            {t('vendors.responsibleData')}
                        </div>

                        <div className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm'>
                            <div className='overflow-auto custom-scrollbar'>
                                <table className='min-w-[720px] w-full border-collapse'>
                                    <thead className='bg-slate-100 text-xs uppercase tracking-wide text-slate-500'>
                                        <tr>
                                            <th className='px-3 py-3 text-center font-semibold'>#</th>
                                            <th className='px-3 py-3 text-start font-semibold'>
                                                {t('vendors.responsibleName')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('vendors.mobileNumber')}
                                            </th>
                                            <th className='px-3 py-3 text-start font-semibold'>
                                                {t('vendors.email')}
                                            </th>
                                            <th className='px-3 py-3 text-center font-semibold'>
                                                {t('table.actions')}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>{responsiblesList}</tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ResponsiblesForm;
